import {
  emailValidation,
  passwordValidations,
  required,
} from '@app/dashboard/utils/formValidations';

import type { TFunction } from 'i18next';

export const NOTIFICATION_FLAGS = {
  SKIP_CUSTOMER_TRANSACTION_EMAIL: 'skip_customer_transaction_email',
  MERCHANT_TRANSACTION_EMAIL_NOTIFICATION:
    'merchant_transaction_email_notification',
  UPON_QUICK_LINK_CREATION_NOTIFICATION:
    'upon_quick_link_creation_notification',
};

export const CONSUMER_NOTIFICATION_OPTIONS = (t: TFunction) => [
  {
    title: t(
      'innerLayout.notificationsPage.consumers.labels.transactionEmailNotifications'
    ),
    flag: NOTIFICATION_FLAGS.SKIP_CUSTOMER_TRANSACTION_EMAIL,
  },
  {
    title: t('innerLayout.notificationsPage.consumers.labels.autoSendEmails'),
    flag: NOTIFICATION_FLAGS.UPON_QUICK_LINK_CREATION_NOTIFICATION,
  },
];

export const ADD_EMAIL_FIELD_INITIAL_STATE = (t: TFunction) => ({
  email: {
    errorMsg: '',
    validations: [required, emailValidation],
    isValid: false,
    value: '',
  },
});

export const ADD_PASSWORD_FIELD_INITIAL_STATE = (t: TFunction) => ({
  password: {
    errorMsg: '',
    validations: [required, ...passwordValidations],
    isValid: false,
    value: '',
  },
});

export const FIELDS = {
  EMAIL: 'email',
  PASSWORD: 'password',
};

export const NOTIFICATION_CATEGORIES = {
  NOTIFICATION: 'notification',
};

export const MODALS_TYPES = {
  ADD: 'add',
  DELETE: 'delete',
  CONFIRMATION: 'confirmation',
} as const;

export const PAGE_SIZE_OPTIONS = [5, 10, 20];
export const DEFAULT_PAGINATION = {
  currentPage: 1,
  currentPageSize: PAGE_SIZE_OPTIONS[0],
};

export const MIN_NUMBER_OF_EMAILS = 1;
export const MAX_NUMBER_OF_EMAILS = 5;
